import React from 'react';

import AiFlaggedBadge from '../AiFlaggedBadge/AiFlaggedBadge';
import styles from './SnapshotField.module.css';

export interface SnapshotFieldProps {
  label: React.ReactNode;
  flagged: boolean;
  children: React.ReactNode;
  testId?: string;
}

export function SnapshotField({
  label,
  flagged,
  children,
  testId,
}: SnapshotFieldProps): React.ReactElement {
  return (
    <div
      className={`${styles.field} ${flagged ? styles.flagged : ''}`}
      data-testid={testId}
      data-flagged={flagged}
    >
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        {flagged ? <AiFlaggedBadge /> : null}
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}

export default SnapshotField;
